/// <amd-module name="typeahead/core/presentation/DropdownContentHandlersAssembly" />

import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";
import {IDropdownContentHandler} from "typeahead/core/presentation/IDropdownContentHandler";

export class DropdownContentHandlersAssembly {
    private handlers: IDropdownContentHandler[];

    public constructor(pluginAssembly: IPluginAssembly) {
        this.handlers = pluginAssembly.get(DefaultPluginAssembly.dropdownContentHandler);
    }

    public runHandlers($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        this.handlers.map((plugin: IDropdownContentHandler): void => {
            return plugin.handleContentToShow($dropDownElement, $inputElement, context);
        });
    }
}
